import React from "react";
import { createStore, compose, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import createRootReducer from "./reducers";
import effectMiddleware from './sagaEffectMiddleware'
import * as  Endpoint from "../endpoints";
import createSagaMiddleware from "redux-saga";

import createhavainnotSagas from '../havainnot/store/sagas'
import { getSgAuthStorage } from "../../sg-auth/services/SgAuthStorage";
import { getAuthService } from "../../sg-auth/services/SgAuthService";
import { getSgApiService } from "../../sg-core";
import { getContextService } from "../havainnot/services/contextService";
import { getObservationService } from "../havainnot/services/observationService";
import { getPersonService } from "../havainnot/services/personService";
import { getFormContextService } from "../havainnot/services/formContextService";
import { AUTH_COOKIE } from "../../@common/constants/StorageKeys";
import { getCommonService } from "../../@common/services/CommonService";


export const apiService = getSgApiService("");

export const authStorage = getSgAuthStorage("havainnot-app:auth", sessionStorage)
const storageKey = AUTH_COOKIE;

const authService = getAuthService(
    Endpoint.Auth.path,
    false,
    [apiService] // Services that require token
);

export const ServiceContext = {
    auth: authService,
    havainnotApi: apiService,
    observation: getObservationService(apiService, Endpoint.havainnot, false),
    formContext: getFormContextService(apiService, Endpoint.havainnot),
    context: getContextService(apiService, Endpoint.havainnot),
    person: getPersonService(apiService, Endpoint.havainnot, false),
    common: getCommonService(apiService, Endpoint.Yleiset)
}

// Generate redux middlewares (redux-sage & devtools)
const sagaMiddleware = createSagaMiddleware({
    context: ServiceContext, // Inject services
    effectMiddlewares: [effectMiddleware]
});

const middlewares = [applyMiddleware(sagaMiddleware)];

if ((window as any).__REDUX_DEVTOOLS_EXTENSION__ && process.env.NODE_ENV !== "production") {
    middlewares.push((window as any).__REDUX_DEVTOOLS_EXTENSION__());
}

const rootReducer = createRootReducer()

const createReduxStore = () => {

    const store = createStore(
        rootReducer,
        compose(...middlewares),
    );



    const havainnotSagas = createhavainnotSagas(
        authService,
        getContextService(apiService, Endpoint.havainnot),
        getObservationService(apiService, Endpoint.havainnot, false),
        getPersonService(apiService, Endpoint.havainnot, false),
        getFormContextService(apiService, Endpoint.havainnot)
    )

    sagaMiddleware.run(havainnotSagas);


    return store
}

export const store = createReduxStore()


export const StoreProvider: React.FC = ({ children }) => (
    <Provider store={store}>
        {children}
    </Provider>
);
